import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";

import LibraryControlAction from "../../actions/v2/plan";
import { getText } from "../../helpers";


const UnwantedEventLogsModalTable = (props) => {
  const perPage = 15;
  const [changeLogs, setChangeLogs] = useState([]);
  const [page, setPage] = useState(1);

  const setNewPage = () => {
    if (props.plan.changeLogs.length < perPage) return;
    setPage(page + 1);
  };

  useEffect(() => {
    props.getPlanChangeLogs({
      plan_id: props.planId,
      per_page: perPage,
      page,
      log_filters: props.filters,
    });
  }, [page, props.filters]);

  useEffect(() => {
    if (page == 1) return setChangeLogs(props.plan.changeLogs);
    setChangeLogs(changeLogs.concat(props.plan.changeLogs));
  }, [props.plan.changeLogs]);

  useEffect(() => {
    setPage(1);
  }, [props.filters]);

  return (
    <InfiniteScroll
      dataLength={changeLogs.length}
      next={setNewPage}
      hasMore={true}
      height={1}
    >
      <div className="unwanted-event-logs-content">
        {changeLogs && changeLogs.length > 0 ? (
          <table className="table unwanted-event-logs-table">
            <thead>
              <tr>
                <th className="date-header">{getText("Date Created")}</th>
                <th className="description-header">{getText("Description")}</th>
              </tr>
            </thead>
            <tbody>
              {changeLogs.map((log, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {moment(log.created_at).format("DD MMM YYYY hh:mm A")}
                    </td>
                    <td>{log.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <span>{getText("No changes found")}</span>
        )}
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = (state) => {
  return { plan: state.plan };
};

const mapDispatchToProps = (dispatch) => {
  const libraryControlAction = new LibraryControlAction();

  return {
    getPlanChangeLogs: (options) => {
      dispatch(libraryControlAction.getPlanChangeLogs(options));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnwantedEventLogsModalTable);



// WEBPACK FOOTER //
// ./src/views/unwanted_event_logs_modal/unwanted_event_logs_modal_table.js